<template>
  <div class="event-overview">
    <div class="salutation">
      <h2 class="font-semibold text-3xl mb-4">
        Hey {{ user.name }}!
      </h2>
      <p class="text-gray-700 mb-10">
        Wähle aus einem deiner Events um fortzufahren.
      </p>
    </div>
    <div class="w-full flex flex-wrap -mx-4">
      <mj-event-card :events="events" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventCard from '@/components/event/EventCard.vue';

export default {

  components: {
    'mj-event-card': EventCard,
  },

  computed: {
    ...mapGetters(['events', 'user']),
  },

  watch: {
    events: {
      immediate: true,
      handler(events) {
        if (events.length === 1) {
          this.$router.push({ name: 'event.track.search' });
        }
      },
    },
  },

};

</script>
